import { Link } from 'react-router-dom';

function Landing(){
    return (
        <div>
            <h1>From CD to music card...</h1>
        <Link to='/land'>
            <button>Try now</button>
        </Link>
        <Link to='/link'>
            <button>Download</button>
        </Link>
        </div>
    );

}

export default Landing;